import { translate } from '@gig/magic-common';
import { __spreadArray } from 'tslib';
import { ValidationDisplay, required, minLength, maxLength, containsLetter } from '@gig/magic-form-builder';

function freeText(question) {
    return {
        id: question.text,
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        properties: {
            placeholder: translate('questionnaire.free-text-answer'),
        },
        isOptional: question.isOptional,
        validationDisplay: ValidationDisplay.OnTouchHighlight,
        validation: __spreadArray(__spreadArray([], (!question.isOptional
            ? [
                {
                    name: 'required',
                    fn: required,
                    message: translate('sign-up-step-two.first-name.required-error'),
                },
            ]
            : [])), [
            {
                name: 'min-length',
                fn: minLength(2),
                message: translate('sign-up-step-two.first-name.min-length-error'),
            },
            {
                name: 'max-length',
                fn: maxLength(300),
                message: translate('sign-up-step-two.first-name.max-length-error'),
            },
            {
                name: 'contains-letter',
                fn: containsLetter,
                message: translate('sign-up-step-two.first-name.contains-letter-error'),
            },
        ]),
    };
}

export { freeText };
